<div class="detailed-report-container container-fluid p-2">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <h5 class="text-primary mb-0 fw-bold">
      <i class="bi bi-file-earmark-bar-graph me-1"></i>Detailed Billing Report
    </h5>
    <button
      class="btn btn-primary btn-sm shadow-sm"
      (click)="fetchReport()"
      [disabled]="isLoading"
    >
      <i class="bi bi-arrow-clockwise"></i> Refresh
    </button>
  </div>

  <div class="card shadow-sm mb-2 border-0" style="background-color: #f8f9fa">
    <div class="card-body p-2">
      <div class="row g-2">
        <div class="col-12 col-xl-7">
          <div class="d-flex flex-wrap gap-1">
            <button
              type="button"
              class="btn btn-xs shadow-sm"
              [ngClass]="selectedPreset === 'today' ? 'btn-primary' : 'btn-outline-secondary bg-white'"
              (click)="setRelative('today')"
            >Today</button>
            <button
              type="button"
              class="btn btn-xs shadow-sm"
              [ngClass]="selectedPreset === 'yesterday' ? 'btn-primary' : 'btn-outline-secondary bg-white'"
              (click)="setRelative('yesterday')"
            >Yesterday</button>
            <button
              type="button"
              class="btn btn-xs shadow-sm"
              [ngClass]="selectedPreset === 'weekToDate' ? 'btn-primary' : 'btn-outline-secondary bg-white'"
              (click)="setRelative('weekToDate')"
            >Week</button>
            <button
              type="button"
              class="btn btn-xs shadow-sm"
              [ngClass]="selectedPreset === 'monthToDate' ? 'btn-primary' : 'btn-outline-secondary bg-white'"
              (click)="setRelative('monthToDate')"
            >Month</button>
            <button
              type="button"
              class="btn btn-xs shadow-sm"
              [ngClass]="selectedPreset === 'yearToDate' ? 'btn-primary' : 'btn-outline-secondary bg-white'"
              (click)="setRelative('yearToDate')"
            >Year</button>
            <button
              type="button"
              class="btn btn-xs shadow-sm"
              [ngClass]="selectedPreset === 'previousMonth' ? 'btn-primary' : 'btn-outline-secondary bg-white'"
              (click)="setRelative('previousMonth')"
            >Prev. Month</button>
          </div>
        </div>
        <div class="col-6 col-xl-2">
          <div class="input-group input-group-sm">
            <span class="input-group-text bg-white border-end-0">From</span>
            <input type="date" class="form-control border-start-0 ps-0" [(ngModel)]="fromDate" (change)="onDateChange()" />
          </div>
        </div>
        <div class="col-6 col-xl-2">
          <div class="input-group input-group-sm">
            <span class="input-group-text bg-white border-end-0">To</span>
            <input type="date" class="form-control border-start-0 ps-0" [(ngModel)]="toDate" (change)="onDateChange()" />
          </div>
        </div>
        <div class="col-md-12 col-xl-1">
          <button class="btn btn-success btn-sm w-100 shadow-sm" (click)="fetchReport()" [disabled]="isLoading">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm mb-3 border-0 bg-primary text-white">
    <div class="card-body p-2">
      <div class="row text-center g-0 mb-2">
        <div class="col-md-3 border-end border-white border-opacity-25">
          <small class="d-block opacity-75 x-small">Total Billed</small>
          <h5 class="mb-0 fw-bold">{{ formatCurrency(totalBilled) }}</h5>
        </div>
        <div class="col-md-3 border-end border-white border-opacity-25">
          <small class="d-block opacity-75 x-small">Total Discount</small>
          <h5 class="mb-0 fw-bold text-warning">{{ formatCurrency(totalDiscounted) }}</h5>
        </div>
        <div class="col-md-3 border-end border-white border-opacity-25">
          <small class="d-block opacity-75 x-small">Total Collected</small>
          <h5 class="mb-0 fw-bold text-info">{{ formatCurrency(totalCollected) }}</h5>
        </div>
        <div class="col-md-3">
          <small class="d-block opacity-75 x-small">Total Items</small>
          <h5 class="mb-0 fw-bold">{{ reportData.length }}</h5>
        </div>
      </div>
      <div class="row text-center g-0 pt-1 border-top border-white border-opacity-25">
        <div class="col-md-4 border-end border-white border-opacity-25">
          <small class="d-block opacity-75 x-small">Cash</small>
          <span class="fw-bold">{{ formatCurrency(totalCash) }}</span>
        </div>
        <div class="col-md-4 border-end border-white border-opacity-25">
          <small class="d-block opacity-75 x-small">Card</small>
          <span class="fw-bold">{{ formatCurrency(totalCard) }}</span>
        </div>
        <div class="col-md-4">
          <small class="d-block opacity-75 x-small">UPI</small>
          <span class="fw-bold">{{ formatCurrency(totalUPI) }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm border-0 overflow-hidden">
    <div class="table-responsive" style="max-height: 55vh">
      <table class="table table-hover align-middle mb-0 compact-table">
        <thead class="sticky-top table-primary">
          <tr>
            <th style="width: 30px"></th>
            <th>Date</th>
            <th>Bill #</th>
            <th>Customer</th>
            <th class="text-end">Total Amt</th>
            <th class="text-end">Disc</th>
            <th class="text-end">Cash</th>
            <th class="text-end">Card</th>
            <th class="text-end">UPI</th>
          </tr>
        </thead>
        <tbody *ngFor="let bill of groupedReport" class="border-bottom">
          <!-- Bill Header Row -->
          <tr class="bg-light cursor-pointer" (click)="toggleBill(bill.billingNumber)">
            <td>
              <i class="bi" [ngClass]="expandedBills.has(bill.billingNumber) ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
            </td>
            <td class="small">{{ formatDate(bill.date) }}</td>
            <td class="fw-bold text-primary">{{ bill.billingNumber }}</td>
            <td class="small">{{ bill.customerName || 'N/A' }}</td>
            <td class="fw-bold text-end">{{ formatCurrency(bill.finalAmount) }}</td>
            <td class="text-danger text-end small">{{ formatCurrency(bill.discount) }}</td>
            <td class="text-success text-end small">{{ formatCurrency(bill.cash) }}</td>
            <td class="text-info text-end small">{{ formatCurrency(bill.card) }}</td>
            <td class="text-primary text-end small">{{ formatCurrency(bill.upi) }}</td>
          </tr>

          <!-- Item Details (Expanded) -->
          <tr *ngIf="expandedBills.has(bill.billingNumber)">
            <td colspan="9" class="p-0">
              <div class="p-2 bg-white shadow-inner">
                <table class="table table-sm table-bordered mb-0 x-small text-muted bg-light">
                  <thead class="bg-secondary text-white">
                    <tr>
                      <th>Product Name</th>
                      <th>HSN</th>
                      <th class="text-center">Qty</th>
                      <th class="text-end">Cost</th>
                      <th class="text-end">Sell</th>
                      <th class="text-end">Val</th>
                      <th class="text-center">%</th>
                      <th class="text-end">GST Amt</th>
                      <th class="text-end">Disc</th>
                      <th class="text-end">Final</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of bill.items">
                      <td style="white-space: normal; min-width: 10rem">{{ item.productName }}</td>
                      <td>{{ item.hsnCode }}</td>
                      <td class="text-center">{{ item.quantity | number : "1.0-3" }}</td>
                      <td class="text-end">{{ formatCurrency(item.costPrice) }}</td>
                      <td class="text-end">{{ formatCurrency(item.sellingPrice) }}</td>
                      <td class="text-end">{{ formatCurrency(item.totalValue) }}</td>
                      <td class="text-center">{{ item.taxPercentage }}%</td>
                      <td class="text-end">{{ formatCurrency(item.cgst + item.sgst) }}</td>
                      <td class="text-end text-danger">{{ formatCurrency(item.discount) }}</td>
                      <td class="text-end fw-bold text-dark">{{ formatCurrency(item.finalAmount) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>

        <!-- Empty State -->
        <tbody *ngIf="groupedReport.length === 0 && !isLoading">
          <tr>
            <td colspan="9" class="text-center py-5">
              <div class="text-muted">
                <i class="bi bi-inbox fs-1 d-block mb-3"></i>
                No data available for the selected range.
              </div>
            </td>
          </tr>
        </tbody>

        <!-- Loading State -->
        <tbody *ngIf="isLoading">
          <tr>
            <td colspan="9" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted">Fetching report data...</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <div class="card-footer bg-white border-top p-3 d-flex align-items-center justify-content-between" *ngIf="allGroupedReport.length > 0">
      <div class="d-flex align-items-center gap-3">
        <div class="d-flex align-items-center gap-2">
          <select class="form-select form-select-sm shadow-sm" style="width: auto" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
          </select>
          <span class="small text-muted">Entries Per Page</span>
        </div>
        <div class="small text-muted border-start ps-3">
          Showing <strong>{{ (currentPage - 1) * pageSize + 1 }}</strong> to 
          <strong>{{ Math.min(currentPage * pageSize, allGroupedReport.length) }}</strong> of 
          <strong>{{ allGroupedReport.length }}</strong> bills
        </div>
      </div>
      <nav aria-label="Page navigation">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <button class="page-link" (click)="prevPage()" aria-label="Previous">
              <i class="bi bi-chevron-left"></i>
            </button>
          </li>
          
          <ng-container *ngFor="let p of getPages()">
            <li class="page-item" *ngIf="p !== '...'" [class.active]="currentPage === p">
              <button class="page-link" (click)="goToPage(p)">{{ p }}</button>
            </li>
            <li class="page-item disabled" *ngIf="p === '...'">
              <span class="page-link">...</span>
            </li>
          </ng-container>

          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <button class="page-link" (click)="nextPage()" aria-label="Next">
              <i class="bi bi-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
